import { Alert } from '@cotera/client/app/components/ui';

export const DisplayError: React.FC<{
  error: { name?: string; errorType?: string; message?: string };
}> = ({ error }) => {
  if (error === null || typeof error !== 'object') {
    // eslint-disable-next-line no-console
    console.error('INVALID ERROR THROWN', error);
  }
  const { name, errorType, message } = error ?? {};

  const hasMeaningfulMessage =
    typeof message === 'string' && message.trim().length > 0;
  const displayMessage = hasMeaningfulMessage
    ? message
    : 'Something went wrong. Please try again.';

  return (
    <div className="mt-20">
      <Alert
        variant="error"
        message={displayMessage}
        detail={
          (name !== undefined || errorType !== undefined) &&
          (name !== 'Error' || errorType !== undefined) ? (
            <div className="flex flex-col w-full">
              <h3 className="mb-2 font-medium">
                {name ?? errorType ?? 'Error'}
              </h3>
            </div>
          ) : undefined
        }
      />
    </div>
  );
};
